export default __webpack_public_path__ + "static/media/zoom-out.5abe65ab.svg";